module.exports = __webpack_public_path__ + "img/หอยเชลล์.34c273e5.jpg";